import React from "react";
import { SpinnerLoading } from "../shared/Spinner/SpinnerLoading";
import { InactiveText } from "./Grid.styles";

export const LoadingRowsRenderer: React.FC = () => (
  <InactiveText>
    <SpinnerLoading />
  </InactiveText>
);
